import { ProgressBarChart } from '@seek/charts';
import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import React, { type FunctionComponent } from 'react';

import translations from '@seek/rr-caja/src/.vocab';

interface CustomQuestionHeaderProps {
  selected: number;
  customQuestionsSelectionLimit: number;
}

export const CustomQuestionHeader: FunctionComponent<
  CustomQuestionHeaderProps
> = ({
  selected,
  customQuestionsSelectionLimit: customQuestionsSelectionLimit,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="medium">
      <Heading level="4">{t('custom.headerTitle')}</Heading>
      <Stack space="small">
        <Text weight="medium" tone={selected > 0 ? 'neutral' : 'secondary'}>
          {t('customquestions.created', {
            selected: selected.toString(),
            customQuestionsSelectionLimit:
              customQuestionsSelectionLimit.toString(),
          })}
        </Text>
        <ProgressBarChart
          color={vars.backgroundColor.formAccent}
          progress={(selected / customQuestionsSelectionLimit) * 100}
        />
      </Stack>
    </Stack>
  );
};
